import Serializer from 'umg-ember-backend/serializers/application';

export default class AudioplayerSerializer extends Serializer {
  attrs = {
    cover: 'assetId',
  };
}
